export const es = {
  locale: 'es',
  nav: {
    setup: 'Centro de Control',
    news: 'Noticias',
    brand: 'Simulador WC26',
    teamName: 'Equipo',
    tactics: 'Táctica',
    fixtures: 'Partidos',
    standings: 'Clasificación',
    knockout: 'Eliminatorias',
    teamStats: 'Estadísticas Equipo',
    playerStats: 'Estadísticas Jugadores',
  },
  landing: {
    title: 'Simulación Copa del Mundo',
    subtitle: 'Del partido inaugural a la final. Elige tu asiento como espectador o toma el mando como seleccionador.',
    audienceMode: {
      title: 'Modo Espectador',
      subtitle: 'Visión Completa del Torneo',
      desc: 'Avanza por cada partido del torneo, siguiendo noticias, clasificaciones, cuadros eliminatorios y estadísticas.',
    },
    coachMode: {
      title: 'Modo Entrenador',
      subtitle: 'Toma las Riendas de una Selección',
      desc: 'Selecciona una selección nacional y siéntate en el banquillo. Revisa tu plantilla, ajusta formación, mentalidad, presión y enfoque ofensivo.',
    },
    completed: 'Finalizados',
    upcoming: 'Próximos',
    championRanking: 'Simulación Campeón',
    coachPickRanking: 'Elecciones Entrenadores',
    noCompleted: 'No hay partidos finalizados aún.',
    noUpcoming: '',
    noCoachPick: 'No hay selecciones de modo Entrenador registradas.',
    coachSetup: {
      title: 'Elige tu Equipo y Llávalo a la Gloria',
      back: 'Volver',
      start: 'Comenzar mi Aventura',
      processing: 'Creando aventura',
      hiddenTeamsOpen: "Mostrar Equipos Ocultos",
      hiddenTeamsClose: "Ocultar Equipos Ocultos",
    },
    rosterInfo: 'Grupo {group} · {count} Jugadores',
    simKicker: {
      audience: 'Modo Espectador · Cobertura Total',
      coach: 'Modo Entrenador · Grupo {group}',
    },
    simTitle: {
      audience: 'Centro de Cobertura Total',
      coach: '{flag} La Aventura de {name}',
    },
    warning: {
      leave: 'Salir perderá los datos de la simulación actual.',
      confirm: 'Salir perderá los datos de la simulación. ¿Estás seguro?',
    },
    groupLabel: 'Grupo {id}',
    championCount: '{count} veces',
    coachPickCount: '{count} elecciones',
  },
  common: {
    continue: 'Continuar',
    processing: 'Procesando',
    completed: 'Completado',
    close: 'Cerrar',
    back: 'Volver',
    vs: 'VS',
    restart: 'Nueva partida',
    restartConfirm: '¿Iniciar una nueva partida? Se borrarán el progreso actual y los datos locales guardados.',
    playAgain: 'Jugar de nuevo',
  },
  team: {
    tab: {
      players: 'Jugadores',
      fixtures: 'Partidos',
      tactic: 'Táctica',
    },
    playerTable: {
      player: 'Jugador',
      club: 'Club',
      status: 'Estado',
      position: 'Pos',
      ability: 'Media',
      age: 'Edad',
      caps: 'Sel',
      ntGoals: 'Sel G',
      apps: 'PJ',
      goals: 'G',
      assists: 'A',
      rating: 'Med',
    },
    status: {
      redCard: 'Tarjeta Roja',
    },
    noTactic: 'Este equipo no tiene partidos completados aún.',
    tactic: {
      formation: 'Formación',
      mentality: 'Mentalidad',
      width: 'Amplitud',
      tempo: 'Ritmo',
      passing: 'Pase',
      attackRoute: 'Enfoque Ataque',
      transition: 'Transición',
      pressing: 'Presión',
      defensiveLine: 'Línea Defensiva',
      possession: 'Posesión',
    },
  },
  tactics: {
    formation: 'Formación',
    more: 'Más Formaciones',
    roster: {
      title: 'Plantilla',
      order: '#',
      status: 'Estado',
      name: 'Nombre',
      position: 'Pos',
      ability: 'Media',
      apps: 'PJ',
      goals: 'G',
      assists: 'A',
    },
    emptySlot: 'Vacío',
    noData: 'Sin datos tácticos',
    benchPrefix: 'Sup',
    starterPrefix: 'XI',
  },
  stats: {
    team: {
      title: 'Estadísticas Equipo',
      subtitle: 'Ordenado por rendimiento acumulado',
      noData: 'Sin datos de equipo.',
      ranking: 'Clasificación',
      value: 'Valor',
      matches: 'Partidos',
    },
    player: {
      title: 'Estadísticas Jugadores',
      subtitle: 'Clasificación Jugadores',
      noData: 'Sin datos de jugadores.',
      nationality: 'País',
      value: 'Valor',
      apps: 'PJ',
    },
    playerTotals: {
      title: 'Totales de Plantilla',
      subtitle: 'Solo partidos completados.',
      noData: 'Tu equipo aún no ha jugado.',
    },
    groups: {
      overall: 'General',
      form: 'Forma',
      discipline: 'Disciplina',
      attack: 'Ataque',
      creative: 'Creatividad',
      goalkeeping: 'Portería',
    },
    items: {
      avgPossession: 'Posesión Media',
      goalsFor: 'Goles a Favor',
      xg: 'xG',
      shots: 'Disparos',
      formText: 'Forma',
      winStreak: 'Racha Victorias',
      unbeatenStreak: 'Racha Invencible',
      winlessStreak: 'Racha Sin Ganar',
      scorelessStreak: 'Racha Sin Gol',
      yellowCards: 'Tarjetas Amarillas',
      redCards: 'Tarjetas Rojas',
      fouls: 'Faltas',
      goals: 'Goles',
      assists: 'Asistencias',
      minutesPerGoal: 'Min/Gol',
      apps: 'Partidos',
      starts: 'Titular',
      averageRating: 'Media Puntuación',
      keyPasses: 'Pases Clave',
      passesAttempted: 'Pases',
      passCompletion: '% Pases',
      saves: 'Paradas',
    },
    descriptions: {
      avgPossession: 'Posesión media en partidos completados',
      goalsFor: 'Total de goles marcados',
      xg: 'xG total acumulado',
      shots: 'Total de disparos',
      formText: 'Forma reciente',
      winStreak: 'Victorias consecutivas actuales',
      unbeatenStreak: 'Racha invicta actual',
      winlessStreak: 'Racha sin ganar actual',
      scorelessStreak: 'Partidos sin marcar consecutivos',
      yellowCards: 'Total tarjetas amarillas',
      redCards: 'Total tarjetas rojas',
      fouls: 'Total faltas',
      playerGoals: 'Clasificación de goleadores',
      playerAssists: 'Clasificación de asistencias',
      playerXg: 'Clasificación xG jugadores',
      playerShots: 'Clasificación de disparos',
      minutesPerGoal: 'Minutos por gol',
      playerApps: 'Clasificación de apariciones',
      playerStarts: 'Partidos con 45+ minutos',
      playerYellowCards: 'Tarjetas amarillas jugadores',
      playerRedCards: 'Tarjetas rojas jugadores',
      playerAvgRating: 'Puntuación media',
      playerKeyPasses: 'Pases clave jugadores',
      playerPasses: 'Total pases intentados',
      playerPassCompletion: 'Porcentaje de acierto en pases',
      playerSaves: 'Clasificación de paradas',
    },
  },
  position: {
    gk: 'Porteros',
    def: 'Defensas',
    mid: 'Centrocampistas',
    fwd: 'Delanteros',
  },
  stage: {
    'Group Stage': 'Fase de Grupos',
    'Round of 32': '32avos de Final',
    'Round of 16': 'Octavos de Final',
    'Quarter-final': 'Cuartos de Final',
    'Semi-final': 'Semifinal',
    'Third Place': 'Tercer Puesto',
    'Final': 'Final',
  },
  match: {
    penaltyMarker: 'P',
    extraTimeMarker: 'TE',
    penalty: {
      scored: 'Anotado',
      missed: 'Fallado',
    },
    status: {
      finished: 'Finalizado',
      notStarted: 'No Empezado',
      pending: 'Pendiente',
    },
    viewDetail: 'Ver Detalles',
    modal: {
      teamData: 'Datos Equipo',
      playerData: 'Datos Jugadores',
      finalResult: 'Resultado Final',
      restart: 'Jugar Otra Vez',
      subtitle: {
        extra: 'T.R. {normal}, T.E. {extra}.',
        penalty: 'T.R. {normal}, T.E. {extra}, Pen. {penalty}, {winner} avanza.',
      },
    },
    shootout: 'Tanda de Penaltis',
    extraTime: 'Prórroga',
    decision: {
      penalty: ' · Pen. {home}-{away}',
      extra: ' · T.E. {home}-{away}',
    },
    news: {
      penalty: 'El partido terminó {normal} tras el tiempo reglamentario y {extra} tras la prórroga; {winner} ganó {penalty} en los penaltis.',
      extraTime: 'El partido terminó {normal} tras el tiempo reglamentario, con {goals} goles más en la prórroga. Resultado final: {final}.',
    },
    fallback: '{home} y {away} terminaron {score} en {stage}.',
    eventsFallback: 'El partido se decidió en el medio campo y los detalles defensivos.',
    xg: 'xG {home}/{away}',
    possession: 'Posesión {home}/{away}',
    shots: 'Disparos {home}/{away}',
    best: 'Mejor {player}',
    simulate: 'Simular',
    simTitle: 'Resultados de la simulación',
    simulating: 'Simulando…',
    simProgress: '10 simulaciones para este partido',
  },
  fixture: {
    title: 'Partidos',
    noDate: 'Sin Jornada',
    prevDay: 'Jornada anterior',
    nextDay: 'Jornada siguiente',
  },
  knockout: {
    title: 'Eliminatorias',
    subtitle: 'El camino de 32avos a la Final',
    tabs: {
      bracket: 'Cuadro',
    },
    stageNotGenerated: 'Esta fase aún no se ha generado.',
    tbd: 'PEND',
  },
  standings: {
    rank: 'Pos',
    team: 'Equipo',
    played: 'PJ',
    wins: 'G',
    draws: 'E',
    losses: 'P',
    goalsFor: 'GF',
    goalsAgainst: 'GC',
    goalDiff: 'DG',
    points: 'Pts',
    filter: 'Filtrar',
  },
  tacticsControls: {
    mentality: {
      label: 'Mentalidad',
      options: ['Ataque Total', 'Atacar', 'Positivo', 'Equilibrado', 'Cauteloso', 'Defensivo', 'Bloque Bajo'],
    },
    width: {
      label: 'Amplitud',
      options: ['Estrecho', 'Bastante Estrecho', 'Normal', 'Bastante Ancho', 'Ancho'],
    },
    tempo: {
      label: 'Ritmo',
      options: ['Lento', 'Bastante Lento', 'Normal', 'Bastante Rápido', 'Rápido'],
    },
    passing: {
      label: 'Pase',
      options: ['Balón Largo', 'Directo', 'Mixto', 'Corto', 'Muy Corto'],
    },
    attackRoute: {
      label: 'Enfoque Ataque',
      options: ['Banda', 'Mixto', 'Centro'],
    },
    transition: {
      label: 'Transición',
      options: ['Salir desde Atrás', 'Construir desde Defensa', 'Mixto', 'Rápido al Medio', 'Rápido Arriba'],
    },
    defensiveLine: {
      label: 'Línea Defensiva',
      options: ['Baja', 'Normal', 'Alta'],
    },
    pressing: {
      label: 'Presión',
      options: ['Baja', 'Media', 'Alta'],
    },
    possession: {
      label: 'Posesión',
      options: ['Repliegue', 'Menos Posesión', 'Equilibrado', 'Más Posesión', 'Control Total'],
    },
  },
  formations: {
    '4-2-3-1A': '4 defensas, 2 MCdef, 2 extremos, 1 MCof, 1 delantero',
    '4-2-3-1S': '4 defensas, 2 MCdef, 1 MC, 2 extremos, 1 delantero',
    '4-3-3': '4 defensas, 3 centrocampistas, 3 delanteros',
    '4-1-4-1': '4 defensas, 1 MCdef, 4 centrocampistas en línea, 1 delantero',
    '4-1-2-2-1': '4 defensas, 1 MCdef, 2 MC, 2 extremos, 1 delantero',
    '4-3-1-2M': '4 defensas, 3 MC, 1 MCof, 2 delanteros',
    '4-3-1-2D': '4 defensas, 3 MCdef, 1 MC, 2 delanteros',
    '4-3-2-1M': '4 defensas, 3 MC, 2 MCof, 1 delantero',
    '4-3-2-1D': '4 defensas, 3 MCdef, 2 MC, 1 delantero',
    '4-3-2-1S': '4 defensas, 3 MC, 2 extremos, 1 delantero',
    '4-4-1-1': '4 defensas, 4 centrocampistas en línea, 1 MCof, 1 delantero',
    '4-2-2-2': '4 defensas, 2 MCdef, 2 extremos, 2 delanteros',
    '4-4-2F': '4 defensas, 4 centrocampistas en línea, 2 delanteros',
    '4-4-2D': '4 defensas, rombo en centro del campo, 2 delanteros',
    '3-3-2-2': '3 DC, 2 carrileros, 1 MCdef, 2 MC, 2 delanteros',
    '3-2-4-1': '3 DC, 2 MCdef, 2 abiertos, 2 MC, 1 delantero',
    '3-2-2-2-1': '3 DC, 2 carrileros, 2 MC, 2 extremos, 1 delantero',
    '3-2-3-2D': '3 DC, 2 MCdef, 2 abiertos, 1 MC, 2 delanteros',
    '3-2-3-2W': '3 DC, 2 carrileros, 3 MC, 2 delanteros',
    '3-4-1-2': '3 DC, 2 carrileros, 2 MCdef, 1 MCof, 2 delanteros',
    '3-4-2-1S': '3 DC, 2 carrileros, 2 MCdef, 2 extremos, 1 delantero',
    '3-4-2-1C': '3 DC, 2 carrileros, 2 MCdef, 2 MCof, 1 delantero',
    '3-4-3F': '3 DC, 4 centrocampistas en línea, 3 delanteros',
    '3-4-3D': '3 DC, rombo en centro del campo, 3 delanteros',
    '5-3-2': '5 defensas, 3 MC, 2 delanteros',
    '5-4-1F': '5 defensas, 4 centrocampistas en línea, 1 delantero',
    '5-4-1D': '5 defensas, rombo en centro del campo, 1 delantero',
    '5-2-2-1': '5 defensas, 2 MCdef, 2 extremos, 1 delantero',
  },
  news: {
    title: 'Noticias',
    subtitle: 'Actualizaciones de los partidos',
    titleTexts: {
      groupRecap: 'Repaso de la Fase de Grupos: Clasificados, Sorpresas y Clasificación',
      knockoutRecap: 'Repaso de {stage}: Clasificados y Puntos de Inflexión',
      stagePreview: 'Previa de {stage}: Partidos Clave y Pronósticos',
      championRoad: '{flag} El Camino a la Gloria de {name}',
      awards: 'Premios del Mundial: Mejor Jugador, Máximo Goleador y Mejor Portero',
      review: 'Resumen del Mundial: Campeón, Sorpresas, Goleadas y Héroes',
      coachSummary: 'Repaso de la Campaña de {team}',
    },
    kicker: {
      author: 'Mensaje del Autor',
      guide: 'Guía Rápida',
      welcome: {
        coach: 'Bienvenido al Banquillo',
        audience: 'Bienvenido al Centro',
      },
      stageRecap: 'Resumen · {stage}',
      stagePreview: 'Avance · {stage}',
      champion: 'Historia del Campeón',
      awards: 'Premios',
      tournamentReview: 'Resumen del Torneo',
      pregame: 'Previa',
      coachSummary: 'Resumen de la Campaña',
    },
    default: {
      title: 'Simulación no iniciada',
      body: 'Una vez que selecciones un modo, las noticias comenzarán.',
    },
    guide: {
      title: 'Continuar te llevará primero a las noticias, luego al avance de la jornada',
      body: 'El botón {Continuar} está en la esquina superior derecha de la página. En modo Espectador, las noticias no leídas se muestran primero. Después de leerlas verás los partidos del día. Haz clic en {Continuar} nuevamente para simular los partidos.',
    },
    author: {
      title: 'Una (gran) nota de agradecimiento del autor',
      body: 'Gracias por soportar el gusto estético de un programador trasnochador. Si la simulación te hizo feliz, felicita al autor; si el resultado fue un batacazo… ¡eso es la belleza del fútbol! Para cualquier comentario, contáctame en x.com/diysimon o Xiaohongshu (diysimon).',
    },
    finalThanks: {
      title: 'Torneo Completado — ¡Gracias por Jugar!',
      body: 'La Copa del Mundo 2026 ha llegado a su fin. ¡Gracias por vivir esta simulación! Sigue al autor (X @diysimon / Xiaohongshu diysimon) para novedades, comentarios y futuros proyectos. ¡No dudes en comenzar una nueva partida y probar un camino diferente!',
    },
    coachSummary: {
      intro: 'Tu aventura con {team} ha llegado a su fin. El equipo terminó en {position}.',
      record: 'A lo largo del torneo, {team} consiguió {wins} victorias, {draws} empates, {losses} derrotas, marcando {goalsFor} goles y recibiendo {goalsAgainst}.',
      position: '{team} terminó en {position} lugar.',
      exit: 'Fueron eliminados en {stage} por {opponent}.',
      exitNone: 'Terminaron el torneo invictos en las eliminatorias.',
      topScorer: 'Máximo goleador: {name} con {goals} gol(es).',
      noScorer: 'Ningún jugador destacó en la tabla de goleadores.',
      bestWin: 'Mayor victoria: {match}.',
      meta: '{wins}V {draws}E {losses}D | {goalsFor}GF {goalsAgainst}GC | {position}',
      factRecord: 'Récord: {wins}V {draws}E {losses}D',
      factGoals: 'Goles: {goalsFor} a favor / {goalsAgainst} en contra (dif {diff})',
      factTopScorer: 'Máx. goleador: {name} ({goals} goles)',
      factChampion: '¡{team} es Campeón del Mundo!',
      factFinish: 'Posición final: {position}',
      positions: {
        champion: 'Campeón',
        runnerUp: 'Subcampeón',
        semiFinal: 'Semifinalista',
        quarterFinal: 'Cuartofinalista',
        round16: 'Octavos de Final',
        round32: '32avos de Final',
        groupStage: 'Fase de Grupos',
      },
    },
    welcome: {
      coach: {
        title: '{flag} {name} comienza su aventura',
        body: 'Has tomado las riendas de {name}. Usa el menú izquierdo para ver tu equipo, táctica, partidos y estadísticas.',
      },
      audience: {
        title: 'Simulación Copa del Mundo 2026 cargada',
        body: 'Estás viendo el torneo como espectador. El sistema avanza partido a partido.',
      },
    },
    facts: {
      thanks: 'Gracias por jugar',
      feedback: 'Comentarios bienvenidos',
      entertainment: 'Simulación solo para entretenimiento',
      newsFirst: 'Noticias más recientes primero',
      fixtureBrowse: 'Partidos por jornada',
      resultsGenerate: 'Resultados generan noticias',
      newsUpdates: 'Noticias se actualizan en directo',
      timeline: 'Calendario de próximos partidos',
      refreshWarning: 'Recargar o salir pierde la simulación',
      operation: 'Cómo jugar',
      preMatch: 'Informe previo',
    },
    narrative: {
      intro: {
        penalty: '{winner} se impuso {score} en la tanda de penaltis tras un intenso duelo de {stage}.',
        extraTime: '{winner} ganó {winnerScore} tras la prórroga para lograr una sufrida victoria de {stage}.',
        win: [
          '{winner} controló el ritmo en {stage} y consiguió una victoria por {score}.',
          '{winner} superó a su rival con un juego sólido en ambas fases del campo, cerrando {score} en {stage}.',
          '{winner} aprovechó los momentos clave de este duelo de {stage}, cerrando {score}.',
          '{winner} no falló en {stage} y se llevó una victoria por {score}.',
          'El partido de {stage} fue reñido desde el inicio, pero el gol decisivo de {winner} dejó el {score}.',
        ],
        draw: [
          'Un tenso duelo de {stage} terminó en tablas: {home} y {away} finalizaron {score}.',
          '{home} y {away} intercambiaron golpes en {stage}, pero ninguno pudo encontrar el gol de la victoria — {score} fue el marcador final.',
          'El duelo de {stage} terminó sin ganador: {home} y {away} se repartieron los puntos en {score}.',
        ],
      },
      noEvent: [
        'Ningún lado logró una ruptura decisiva. El partido se definió por las batallas en el centro del campo y los bloqueos en el último tercio.',
        'Ambas defensas mantuvieron bien su posición, dejando pocas oportunidades reales de gol.',
        'La definición fue la historia del partido: las jugadas prometedoras se rompían en el último momento.',
      ],
      goal: {
        extraTime: [
          '{minute}, la prórroga alcanzó su fase crítica. {scorer} aprovechó el pase de {assister} y {method} para poner el {score}.',
          '{minute}, {team} aprovechó su oportunidad en la prórroga cuando {scorer} {method} superando al portero, {team} {state}.',
          '{minute}, con las piernas cansadas y los espacios abriéndose, {scorer} {method} con calma para enviar el balón a la red, poniendo el {score}.',
          '{minute}, {scorer} protagonizó el momento decisivo de la prórroga, {method} para devolver el control a {team}.',
        ],
        withAssist: [
          '{minute}, {scorer} recibió el centro de {assister} desde la derecha, {method} por delante del defensa para poner el {score}, {team} {state}.',
          '{minute}, {assister} filtró un pase clave, {scorer} lo aprovechó y {method} para marcar, {team} {state}.',
          '{minute}, {team} elaboró una jugada de gran calidad. {assister} cedió para {scorer}, quien {method} para poner el {score}.',
          '{minute}, {scorer} se benefició de la entrega de {assister}, {method} superando al indefenso portero, {team} {state}.',
          '{minute}, {assister} jugó un pase que rompió líneas, {scorer} lo controló en carrera y {method} para marcar — {score}.',
          '{minute}, {team} recuperó el balón en zona adelantada y se movió rápido. {assister} la puso atrás para {scorer}, quien {method} a puerta.',
          '{minute}, {assister} colgó la jugada de estrategia al área. {scorer} se elevó sobre todos y {method}, {team} {state}.',
          '{minute}, {scorer} recibió el pase atrás de {assister} y {method} de primera — la jugada dejó el {score}.',
          '{minute}, {assister} atrajo defensas antes de ceder el balón. {scorer} encontró espacio y {method}, {team} {state}.',
          '{minute}, {team} movió el balón con paciencia hasta que apareció el hueco. {assister} dio el pase final y {scorer} {method} a la red.',
        ],
        solo: [
          '{minute}, {scorer} se deshizo de un defensa en el borde del área y {method}, {team} {state} — {score}.',
          '{minute}, {scorer} aprovechó un despeje defectuoso y {method} a puerta vacía.',
          '{minute}, {scorer} condujo desde el centro del campo hasta el área y soltó un {method} imparable.',
          '{minute}, la presión alta de {team} causó el caos. {scorer} reaccionó más rápido, {method} para poner el {score}.',
          '{minute}, {scorer} reaccionó primero en el barullo, {method} desde corta distancia, {team} {state}.',
        ],
        methodHigh: ['cabezazo', 'empujó', 'picó', 'empalmó desde cerca'],
        methodLow: ['disparo lejano', 'tiro curvado', 'disparo desde la distancia', 'volea'],
        methodMid: ['golpeó', 'colocó', 'fusiló', 'definición serena', 'disparo angulado'],
      },
      chance: [
        '{minute}, {team} estuvo cerca de {chanceState}. {player} encaró al portero pero el guardameta salió victorioso.',
        '{minute}, {player} tuvo una oportunidad de oro dentro del área pero la envió desviada en el último instante.',
        '{minute}, {team} salió rápido al contraataque, pero el disparo de {player} pasó rozando el poste.',
        '{minute}, {player} conectó el centro con buena trayectoria pero no logró dirigirlo a puerta.',
      ],
      redCard: [
        '{minute}, {team} sufrió un duro golpe con la expulsión de {player}, cambiando el rumbo del partido.',
        '{minute}, {player} fue expulsado, obligando a {team} a replegarse durante el resto del encuentro.',
        '{minute}, el árbitro mostró la roja a {player}. El plan de juego de {team} tuvo que cambiar sobre la marcha.',
      ],
      flow: {
        xgGap: '{dominant} generó las mejores ocasiones, liderando {xgHome}-{xgAway} en xG y {shotsHome}-{shotsAway} en disparos.',
        possession: '{controller} dominó el balón con un {possession}% de posesión, pero la eficiencia en el área fue más determinante.',
        balanced: 'La diferencia de calidad en las ocasiones fue estrecha ({xgHome}-{xgAway} xG), con el partido decidido en las transiciones y la ejecución final.',
      },
      tactic: {
        control: [
          'Tácticamente, {controller} dictó el ritmo, manteniendo el balón en movimiento con pases pacientes y un {possession}% de posesión.',
          'El plan de {controller} fue claro: tener el balón, atacar por las bandas y los medios espacios, e impedir que {away} cogiera ritmo.',
          '{controller} usó la posesión sostenida para desgastar la presión rival, manteniendo el partido a su medida.',
          '{controller} se mantuvo compacto y paciente en posesión, convirtiendo la retención del balón en más tiempo en el último tercio.',
        ],
        direct: [
          '{direct} no buscó la posesión — priorizó meter el balón rápido al área, y un mayor número de disparos reflejó ese enfoque.',
          'En ataque, {creator} fue más certero encontrando zonas peligrosas, y su ventaja en pases clave mantuvo a la defensa bajo presión.',
          '{direct} movió el balón con determinación, evitando la congestión del centro del campo y llevando el juego directo al área.',
          '{creator} mostró mayor variedad en el último tercio — centros, pases filtrados y segundas jugadas generaron peligro real.',
        ],
        pressure: [
          '{presser} hizo un enorme trabajo sin balón, dificultando que el rival sacara el balón jugado con limpieza.',
          'La disciplina defensiva de {presser} destacó — los centrocampistas replegaron rápido y sofocaron el peligro antes de que llegara al área.',
          'La intensidad física fue alta. {presser} cortó las líneas de pase con presión incansable y carreras de recuperación.',
          '{presser} fue agresivo al recuperar el balón tras perderlo — no siempre generando disparos, pero sofocando los contraataques.',
        ],
        balanced: [
          'Ambos equipos fueron cautelosos en la ejecución, manteniendo formaciones compactas y dejando el partido en manos de los duelos y segundas jugadas.',
          'No fue un partido abierto. Ninguno abandonó su estructura defensiva, confiando en unos pocos pases clave para abrir la defensa rival.',
          'Ambos equipos gestionaron el riesgo con cuidado, limitando la proyección ofensiva. El partido se definió por momentos puntuales de alta calidad.',
          'Tácticamente, los equipos se anularon mutuamente: uno intentaba acelerar, el otro obstruía los espacios centrales.',
          'Las batallas en el centro del campo interrumpieron el ritmo repetidamente, mostrando que ambos priorizaban las transiciones defensivas.',
        ],
      },
      coach: {
        late: [
          'La paciencia del cuerpo técnico dio sus frutos. {winner} no se precipitó en la segunda mitad, esperando a que el rival se cansara para asestar el golpe definitivo.',
          'Los cambios y la estructura de {winner} se mantuvieron sincronizados, permitiendo una presión sostenida al final — señal de una buena gestión del partido.',
          '{winner} mantuvo su forma en el empate. El gol tardío fue el resultado natural de la presión sostenida, no de la desesperación.',
          'El cuerpo técnico de {winner} optó por seguir presionando en la fase final, una decisión que les dio el momento decisivo.',
        ],
        red: [
          'Tras la roja, el cuerpo técnico de {redTeam} reajustó la formación, confiando en un bloque compacto y salidas rápidas para seguir en el partido.',
          '{opponent} intentó estirar el juego con el hombre de más, pero la respuesta compacta de {redTeam} evitó que el partido se escapara.',
          'Jugar con uno menos puso a prueba la capacidad de adaptación de {redTeam}. Redujeron los pases de riesgo por el centro y priorizaron la solidez defensiva.',
          'El cuerpo técnico de {opponent} instó a mover el balón más rápido tras la roja, intentando convertir la superioridad numérica en superioridad por bandas.',
        ],
        narrow: [
          'El cuerpo técnico de {winner} tomó una decisión pragmática — tras adelantarse, no buscaron más goles, sino que protegieron su ventaja con una sólida colocación.',
          '{winner} priorizó el control tras marcar, reduciendo riesgos innecesarios y manteniendo el partido bajo control.',
          '{winner} ganó sin alardes. La gestión del riesgo del cuerpo técnico fue impecable, dando a {loser} pocas opciones de reaccionar.',
          'La victoria reflejó el enfoque realista de {winner}: asegurar la defensa primero, luego dejar que los atacantes decidieran el partido.',
        ],
        win: [
          '{winner} ejecutó su plan de juego con eficacia, manteniendo la estructura ofensiva incluso tras adelantarse en el marcador.',
          '{winner} se posicionó con inteligencia en las transiciones. El cuerpo técnico claramente exigió presión inmediata sobre el balón tras perderlo.',
          'La victoria de {winner} no fue solo por calidad individual — su formación y protección de segundas jugadas sustentaron el marcador.',
          '{winner} demostró una madura gestión del partido, sabiendo cuándo presionar y cuándo mantener el balón.',
        ],
        draw: [
          'Ningún cuerpo técnico asumió riesgos totales en el empate. Las sustituciones tardías y la colocación se inclinaron hacia evitar la derrota.',
          'Ambos bandos intentaron crear por las bandas, pero la defensa central nunca fue superada de forma consistente.',
          'El empate reflejó la cautela de ambos entrenadores: la intención ofensiva estaba ahí, pero ninguno se comprometió completamente al ataque.',
          'Ambos equipos reforzaron la protección del centro del campo en los minutos finales, más preocupados por un contraataque que decidiera el partido.',
        ],
      },
      player: {
        goals: [
          '{player} fue el nombre destacado, cambiando el partido con múltiples definiciones y obteniendo una valoración de {rating}.',
          'El instinto definidor de {player} decidió el partido — sus desmarques encontraban constantemente los espacios más difíciles de defender.',
          'El ataque de {team} fue culminado por {player}, cuya serenidad al disparar mantuvo a la defensa rival bajo presión constante.',
          '{player} fue el factor diferencial, convirtiendo ocasiones en presión real en el marcador.',
        ],
        attack: [
          '{player} fue influyente en los momentos clave. Más allá de goles y asistencias, su juego de enlace mantuvo a {team} en progresión.',
          'La contribución de {player} fue más allá de las estadísticas — aparecía donde el ataque necesitaba un punto de apoyo.',
          '{player} aprovechó su momento en este partido, tomando las decisiones clave que dieron al ataque de {team} un punto focal.',
          '{player} fue decisivo en el último tercio — sabiendo cuándo pasar y cuándo disparar, un desahogo fiable para {team}.',
          'Los movimientos de {player} crearon espacio, y su participación directa cambió la dinámica del partido.',
        ],
        saves: [
          'La labor de {player} en la portería fue vital. Varias paradas mantuvieron a {team} en el partido.',
          'El portero {player} merece una mención especial, realizando parada tras parada para negar al rival.',
          '{team} resistió bajo presión gracias a los reflejos de {player} — su capacidad de detener disparos fue un factor clave.',
          '{player} tenía poco margen de error, pero lo manejó todo con limpieza, manteniendo la calma incluso ante disparos a quemarropa.',
        ],
        create: [
          '{player} fue el enlace más importante de {team} en el último tercio, creando oportunidades de tiro para sus compañeros con pases clave.',
          'La visión de {player} moldeó los patrones ofensivos de {team} — encontraba constantemente líneas de pase en zonas congestionadas.',
          '{team} necesitaba a alguien que llevara el balón a zonas peligrosas, y {player} cumplió ese papel a la perfección.',
          '{player} no solo buscó el gol — usó el pase para poner a sus compañeros en mejor posición de tiro.',
        ],
        defense: [
          '{player} cubrió mucho terreno defensivamente, con entradas e intercepciones que solidificaron la protección en el centro del campo de {team}.',
          '{team} limitó el avance del rival gracias al repliegue y la anticipación de {player}.',
          'El valor de {player} llegó sin balón, rompiendo repetidamente las jugadas de pase del rival antes de que se desarrollaran.',
          '{player} merece reconocimiento por su trabajo defensivo, salvando a {team} de varias situaciones peligrosas cerca del área.',
        ],
        shots: [
          '{player} no convirtió sus ocasiones en goles, pero sus constantes disparos mantuvieron a la defensa rival al límite.',
          'Gran parte de la amenaza ofensiva de {team} vino de {player}, que intentó una y otra vez abrirse paso a disparos.',
          'La agresividad de {player} fue notable — múltiples disparos mostraron que encontraba constantemente espacio en el último tercio.',
          '{player} no estuvo lejos del gol — sus intentos ya habían puesto al portero rival en máxima alerta.',
        ],
        general: [
          '{player} obtuvo una de las valoraciones más altas, ofreciendo un juego sólido en ambos lados del campo para {team}.',
          'Los números de {player} no cuentan toda la historia — su participación fue crucial para mantener a {team} en ritmo.',
          'El rendimiento completo de {player} fue el más reconocido, tomando la decisión correcta en múltiples situaciones.',
          'El valor de {player} residió en su fiabilidad — rara vez perdía la posesión y siempre estaba disponible para la labor defensiva.',
        ],
      },
      impact: {
        finalWin: '{winner} ganó la final y levantó la Copa del Mundo. La aventura de {loser} terminó a un paso.',
        thirdPlace: '{winner} terminó tercero en la Copa del Mundo, mientras que {loser} ocupó el cuarto puesto.',
        semiFinal: '{winner} avanzó a la final con esta victoria, acabando con las esperanzas de {loser} de levantar el trofeo.',
        quarterFinal: '{winner} alcanzó las semifinales, ahora a solo una victoria de la final.',
        knockoutWin: '{winner} avanza en las eliminatorias, mientras que {loser} queda eliminado.',
        placementBothDark: 'Ambos equipos superaron ampliamente sus cuotas previas al torneo — el partido por el tercer puesto fue en sí mismo una historia de tapados.',
        placementThirdDark: '{thirdName} terminó en el podio desde fuera del top 20 en las cuotas previas, superando todas las expectativas.',
        placementFourthDark: '{fourthName} perdió este partido, pero alcanzar las semifinales ya superó las expectativas previas al torneo.',
        placementBothFavored: 'Ambos equipos están entre los 20 primeros por cuotas previas, y llegar al top 4 cumplió en gran medida las expectativas.',
        groupLead: '{teamName} tiene {points} puntos en {played} partidos de grupo, ocupando el {rank} puesto y en una posición sólida para clasificarse.',
        groupEliminated: '{teamName} tiene solo {points} puntos en {played} partidos, ocupando el {rank} puesto y sin opciones de avanzar.',
        groupUpdate: 'Tras este partido, {teamName} tiene {points} puntos, actualmente {rank} en el Grupo {group}.',
        groupQualifiers: 'Grupo {groupId}: {names}',
        qualified: 'clasificado',
        eliminated: 'eliminado',
        favoriteStatus: '{name} {status}',
        darkHorses: '{names} son los tapados más notables de esta fase, superando las expectativas en puntos, diferencia de goles o partidos clave.',
        noDarkHorses: 'En general, los favoritos mantuvieron su posición — las clasificaciones de grupo no sufrieron grandes sobresaltos.',
        unbeaten: '{names} siguen invictos, mostrando una impresionante consistencia.',
        scorers: 'Individualmente, {scorerLine}. {assisterLine}.{ratingLine}',
        scorerLead: '{name} lidera la tabla de goleadores con {goals} goles',
        scorerDisperse: 'La carrera por el gol sigue abierta',
        assisterLead: '{name} lidera la tabla de asistencias con {assists}',
        assisterDisperse: 'La tabla de asistencias sigue muy reñida',
        ratingHighlight: ' {name} promedia {rating} — uno de los jugadores más destacados de la fase de grupos.',
      },
      recap: {
        groupIntro: [
          'La fase de grupos ha terminado. 32 equipos han avanzado y el Mundial entra en modo eliminatorio.',
          'Ya se han disputado 72 partidos de grupo. Los clasificados, las sorpresas y las tablas individuales han tomado forma.',
          'Fase de grupos finalizada. La consistencia de los favoritos, las irrupciones de tapados y la carrera por el gol definieron esta fase.',
        ],
        knockoutIntro: 'Terminó {stage}. Quedan {count} equipos en la lucha por el campeonato.',
        knockoutWinners: '{names} sellaron su billete a la siguiente ronda.',
        knockoutTight: '{count} partidos se decidieron por un solo gol o fueron a penaltis — la tensión eliminatoria va en aumento.',
        knockoutClear: 'Los resultados de esta ronda fueron relativamente claros, con los ganadores mostrando mayor control.',
        knockoutBiggest: 'El partido más abierto de la ronda fue {match}, con {goals} goles totales.',
        knockoutUpset: 'La sorpresa llegó cuando {winner} venció a {loser} — el equipo peor clasificado produjo la actuación más eficiente.',
        knockoutScorers: 'Individualmente, {scorerLine}; {ratingLine}',
        knockoutScorerLead: '{name} sigue liderando la tabla de goleadores con {goals} goles',
        knockoutScorerDisperse: 'La carrera por el gol sigue abierta',
        knockoutRating: '{name} mantiene una valoración alta, uno de los jugadores más consistentes de la fase eliminatoria.',
        knockoutRatingGeneric: 'El estado de forma de los jugadores clave empieza a definir la carrera por el título.',
        groupLines: 'Clasificados por grupo: {lines}. {favorites}',
        groupFavorites: 'Entre los favoritos, {status}.',
        groupQualifierFormat: 'Grupo {groupId}: {names}',
        groupMeta: '{count} clasificados · {scorerInfo}',
        scorerInfo: 'Goleador {name}',
        scorerInfoUpdate: 'Estadísticas actualizadas',
        factQualified: '{count} clasificados',
        factDarkHorses: 'Tapados {names}',
        factStable: 'Favoritos estables',
        factTopScorer: 'Máximo goleador {name} {goals}G',
        factTopAssister: 'Máximo asistente {name} {assists}A',
        knockoutMeta: '{count} avanzaron · {tight} reñidos',
        factKnockoutTight: '{count} partidos ajustados',
        factKnockoutClear: 'Resultados claros',
        factUpset: 'Sorpresa {winner}',
        factOpen: '{goals} goles',
      },
      preview: {
        intro: 'Los cruces de {stage} están definidos. La siguiente fase reducirá el campo en {count} partidos.',
        keyMatch: 'Enfrentamientos clave a seguir: {matches}.',
        noKeyMatch: 'No hay duelos directos entre equipos del top 20 de cuotas en esta fase — los favoritos deben evitar tropiezos en cruces aparentemente favorables.',
        favorites: 'Por forma y fortaleza de plantilla, {names} parten como favoritos para avanzar.',
        noFavorites: 'La diferencia en esta ronda es estrecha — la forma y la definición pueden importar más que el nombre.',
        tail: [
          'En las eliminatorias, la gestión del partido, la defensa de jugadas de estrategia y el estado de forma del portero se vuelven críticos. Un error puede redefinir todo el cuadro.',
          'Esta fase no es solo potencia ofensiva. El momento de las sustituciones, la gestión del riesgo y la preparación de los penaltis influirán en los resultados.',
          'Los favoritos deben evitar arranques lentos mientras los tapados buscan llevar el partido a su zona de confort. Los primeros 30 minutos marcarán el tono.',
        ],
        previewMeta: '{count} partidos',
        factMatchup: '{count} cruces',
        factFocus: 'Enfoque {matchup}',
        factFavorite: 'Favorito {name}',
      },
      champion: {
        road: 'El camino de {champion} hacia la gloria está completo: {count} partidos, {wins} victorias, {draws} empates, {goalsFor} goles marcados, {goalsAgainst} recibidos.',
        groupPath: 'En la fase de grupos, {champion} aseguró la clasificación pronto: {matches}.',
        knockoutPath: 'En las eliminatorias, superaron a {opponents}.',
        signatureMatch: '{match} fue la actuación que definió su campaña.',
        meta: '{wins}V{draws} · {goalsFor}-{goalsAgainst}',
        drawsText: '{draws}E',
        fact: 'Campeón {champion}',
        factGoal: 'Goles {goalsFor}',
        factConcede: 'Recibió {goalsAgainst}',
        factSignature: 'Clave {match}',
        tail: [
          'La característica definitoria de este campeón fue la estabilidad: controlando los partidos cuando iba ganando y encontrando nuevos recursos ofensivos cuando perdía o estaba estancado.',
          'Su título no se construyó sobre un momento puntual — vino de la solidez defensiva, el rendimiento constante de sus jugadores clave y una dirección técnica afilada.',
          'Lo que distinguió al campeón fue no haberse roto nunca tras un mal resultado, afrontando cada eliminatoria con compostura.',
        ],
      },
      awards: {
        intro: 'Con la final terminada, los premios individuales del Mundial se han decidido. {bestPlayer}',
        bestPlayer: '{name} se llevó el premio al Mejor Jugador con valoraciones altas y actuaciones clave.',
        noBestPlayer: 'La carrera por el Mejor Jugador estuvo muy reñida, con múltiples estrellas ofreciendo actuaciones de clase mundial.',
        topScorer: 'La Bota de Oro es para {name} con {goals} goles — el finalizador más fiable del torneo.',
        noTopScorer: 'La tabla de goleadores no tuvo un líder destacado, pero la eficacia de los delanteros decidió muchos partidos.',
        topAssister: 'En asistencias, {name} lideró con {assists} — sus pases cambiaron directamente múltiples partidos.',
        bestKeeper: 'El Mejor Portero es para {name}, con {saves} paradas y una media de {conceded} goles encajados por partido.',
        noBestKeeper: 'La carrera por el mejor portero se concentró entre unos pocos guardametas consistentes en las eliminatorias.',
        scorerFallback: 'el líder en la tabla de goleadores',
        keeperFallback: 'un candidato a mejor portero',
        summary: '{names} formaron la narrativa individual de este torneo — uno creó, otro finalizó y otro sostuvo la línea defensiva.',
        noSummary: 'Las actuaciones individuales estuvieron fuertemente ligadas a los sistemas de equipo, moldeadas por los marcos tácticos tanto como por la calidad personal.',
      },
      review: {
        intro: 'El torneo ha terminado. {total} partidos produjeron {goals} goles, un promedio de {average} por partido.',
        scoring: '{highScoring} partidos tuvieron 4+ goles, y en {btts} marcaron ambos equipos. {biggest}',
        biggest: 'El partido más abierto fue {match}.',
        upsetSep: 'venció a',
        assisterFallback: 'múltiples asistentes',
        ratingFallback: 'jugadores clave',
        upsets: 'Entre las sorpresas recordamos {upsets}.',
        noUpsets: 'En su mayor parte, los favoritos cumplieron con su ventaja sobre el papel, aunque las eliminatorias a menudo se definieron por detalles.',
        champion: 'Al final, {champion} mantuvo la calma durante más tiempo, convirtiéndose en la historia definitoria del torneo.',
        leaders: 'Individualmente, la definición de {scorer}, la creatividad de {creators} y las altas valoraciones de {ratings} formaron la columna vertebral estadística del torneo.',
        noLeaders: 'Este torneo tuvo tanto dominio como sorpresa — las historias reales fueron más ricas que cualquier estadística aislada.',
        awardsMeta: 'Mejor Jugador {name}',
        awardsMetaDefault: 'Resumen de premios',
        factBestPlayer: 'Mejor Jugador {name}',
        factTopScorer: 'Máximo goleador {name} {goals}G',
        factBestKeeper: 'Mejor POR {name}',
        factTopAssister: 'Líder asistencias {name} {assists}A',
        reviewMeta: '{count} partidos · {goals} goles',
        factTotalGoals: 'Goles totales {goals}',
        factAvgGoals: 'Media {average} por partido',
        factHighScoring: '{count} con 4+ goles',
        factBothScored: '{count} ambos marcaron',
      },
    },
  },
  helpers: {
    formText: { W: 'V', D: 'E', L: 'D' },
    goalState: {
      equalize: 'empatar',
      lead: 'tomar la delantera',
      extend: 'ampliar la ventaja',
      chase: 'recortar distancias',
    },
    chanceState: {
      extend: 'ampliar la ventaja',
      break: 'romper el empate',
      face: 'maquillar el resultado',
      close: 'reducir distancias',
    },
    tacticSummary: 'Mentalidad {mentality} · Juego {focus} · Presión {pressing} · Línea {line}',
    teamMate: 'un compañero',
    attacker: 'un atacante',
    defender: 'un defensor',
    advance: ' avanzó',
    groupLeader: 'Grupo {group}: líder {teamName}, {points} pts',
    unknownPlayer: 'Jugador desconocido',
    unsolved: 'N/D',
    minute: '{minute}\'{stoppage}',
    stoppageTime: '+{minute}',
  },
  rendering: {
    playerTotals: {
      headers: ['Jugador', 'Pos', 'PJ', 'Min', 'G', 'A', 'xG', 'Disp', 'DCP', 'Pas', 'Cmp', 'PC', 'Ent', 'Int', 'TA', 'TR', 'Par', 'Med'],
    },
    matchStats: {
      shotsOnTarget: 'Disparos a Puerta',
      passes: 'Pases',
      passSuccess: '% Pases',
      keyPasses: 'Pases Clave',
      corners: 'Esquinas',
      offsides: 'Fuera de Juego',
      fouls: 'Faltas',
      yellowCards: 'Tarjetas Amarillas',
      redCards: 'Tarjetas Rojas',
      saves: 'Paradas',
      tackles: 'Entradas',
      interceptions: 'Intercepciones',
    },
    modal: {
      best: 'Mejor',
      record: 'Récord',
      stage: 'Fase',
      bestPlayer: 'Mejor Jugador',
      signature: 'Partido Clave',
    },
    bracket: {
      pending: 'Pendiente',
    },
  },
  mobile: {
    landing: { intro: 'Simulador Mundial 2026', description: 'Del partido inaugural a la final, toca Continuar para seguir toda la simulación del Mundial 2026.', welcome: 'Bienvenido a tu propio tiempo mundialista. Toca para simular rápido y predecir quién levantará el trofeo. En PC también está disponible el modo entrenador.', hiddenStart: 'Simular con equipos ocultos', start: 'Iniciar simulación', startTitle: 'Iniciar simulación ahora', startSubtitle: 'Equipos reales, grupos reales y todos los partidos simulados desde la mirada del espectador en menos de diez minutos.', hiddenCheckbox: 'Hacer que Italia, Polonia, Indonesia, China y Emiratos Árabes Unidos participen en el Mundial' },
    topbar: { settings: 'Ajustes' },
    tabs: { navigation: 'Navegación móvil', news: 'Noticias', fixtures: 'Partidos', standings: 'Tabla', knockout: 'Eliminatorias', data: 'Datos' },
    action: { continue: 'Continuar', readNews: 'Leer noticias', simulateNext: 'Simular jornada', restart: 'Reiniciar', completed: 'Completado' },
    settings: { title: 'Ajustes', language: 'Idioma', restart: 'Reiniciar', restartConfirm: '¿Reiniciar y borrar la simulación móvil actual?', close: 'Cerrar ajustes' },
    news: { previous: 'Anterior', next: 'Siguiente', pcMore: 'Usa la versión de PC para más sorpresas y funciones.', empty: 'No hay noticias.' },
    fixtures: { previousDay: 'Jornada anterior', nextDay: 'Jornada siguiente', noMatches: 'No hay partidos en esta jornada.' },
    standings: { groupStandings: 'Tabla de grupos', knockout: 'Eliminatorias', roundOf32: 'Dieciseisavos', roundOf16: 'Octavos', quarterFinal: 'Cuartos', semiFinal: 'Semifinales', thirdPlace: 'Tercer puesto', final: 'Final' },
    data: { goals: 'Goleadores', assists: 'Asistencias', pcMore: 'Usa la versión de PC para ver más datos de jugadores y equipos.', empty: 'No hay datos.' },
    team: { squad: 'Plantilla', fixtures: 'Partidos', tactic: 'Táctica', close: 'Cerrar equipo' },
  },
    teamNames: {

    mexico: 'México', south_africa: 'Sudáfrica', south_korea: 'Corea del Sur',
    czechia: 'Chequia', canada: 'Canadá', bosnia_herzegovina: 'Bosnia y Herzegovina',
    switzerland: 'Suiza', qatar: 'Catar', brazil: 'Brasil', morocco: 'Marruecos',
    scotland: 'Escocia', haiti: 'Haití', united_states: 'Estados Unidos',
    australia: 'Australia', paraguay: 'Paraguay', turkiye: 'Turquía',
    germany: 'Alemania', curacao: 'Curazao', ivory_coast: 'Costa de Marfil',
    ecuador: 'Ecuador', netherlands: 'Países Bajos', japan: 'Japón',
    tunisia: 'Túnez', sweden: 'Suecia', belgium: 'Bélgica', iran: 'Irán',
    egypt: 'Egipto', new_zealand: 'Nueva Zelanda', spain: 'España',
    uruguay: 'Uruguay', saudi_arabia: 'Arabia Saudí', cape_verde: 'Cabo Verde',
    france: 'Francia', senegal: 'Senegal', norway: 'Noruega', iraq: 'Irak',
    argentina: 'Argentina', austria: 'Austria', algeria: 'Argelia',
    jordan: 'Jordania', portugal: 'Portugal', colombia: 'Colombia',
    uzbekistan: 'Uzbekistán', dr_congo: 'RD Congo', england: 'Inglaterra',
    croatia: 'Croacia', panama: 'Panamá', ghana: 'Ghana',
    italy: 'Italia',
    tbd: 'PEND',
    china: 'China',

    indonesia: "Indonesia",
    united_arab_emirates: "EAU",
    poland: "Polonia",

  },
};
